import { IRefIds } from 'constants/refs';

export const getCacheKey = (ref: IRefIds, courseId = 0, sourceDialectId = 0) =>
  `${ref}-${courseId}-${sourceDialectId}`;

export const getClTooltipCacheKey = (ref: IRefIds, courseId: number, refId: number) => `${ref}-${courseId}-${refId}`;
